import React from "react";
import { Link } from "react-router-dom";
import { HERO, IMG } from "@/content/site";

const HeroRaquel = () => (
    <section data-testid="home-hero" data-section-id="hero" className="relative min-h-[100svh] flex items-end overflow-hidden">
        <img
            src={IMG.hero}
            alt="Vista aérea da Amazônia com rio, banco de areia, floresta e áreas ocupadas por estradas e moradias"
            className="absolute inset-0 w-full h-full object-cover hero-kenburns"
            style={{ objectPosition: "60% 45%", filter: "saturate(0.8) contrast(1.05)" }}
        />
        <div aria-hidden="true" className="absolute inset-0" style={{ background: "linear-gradient(90deg, rgba(10,24,18,0.94) 0%, rgba(10,24,18,0.8) 40%, rgba(10,24,18,0.4) 100%)" }} />
        <div aria-hidden="true" className="absolute inset-x-0 bottom-0 h-48 bg-gradient-to-b from-transparent to-[#0E2018]" />
        <div aria-hidden="true" className="absolute inset-0 grain-overlay" />

        <div className="relative w-full max-w-7xl mx-auto px-6 md:px-10 pt-36 pb-20 md:pb-28">
            <div className="max-w-3xl">
                <h1 data-testid="hero-title" className="font-serif italic font-light text-[20px] sm:text-[24px] md:text-[28px] leading-[1.3] text-[#C7A659] max-w-2xl text-balance animate-fade-up" style={{ animationDelay: "200ms" }}>
                    {HERO.title}
                </h1>
                <p className="mt-8 font-sans font-light text-[15px] md:text-[17px] leading-[1.8] text-[#D7D1BF] max-w-2xl animate-fade-up" style={{ animationDelay: "600ms" }}>
                    {HERO.lead}
                </p>
                <div className="mt-12 flex flex-wrap items-center gap-3 animate-fade-up" style={{ animationDelay: "750ms" }}>
                    {HERO.ctas.map((c) => (
                        <Link
                            key={c.to}
                            to={c.to}
                            data-testid={`hero-cta-${c.label.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase()}`}
                            className={`inline-flex items-center gap-3 rounded-full px-7 py-3.5 font-sans text-[11.5px] uppercase tracking-[0.2em] transition-colors ${c.primary ? "bg-[#C7A659] text-[#0A1812] hover:bg-[#d8bb76]" : "border border-[#F2EFE5]/40 text-[#F2EFE5] hover:border-[#F2EFE5] hover:bg-[#F2EFE5]/5"}`}
                        >
                            {c.label}
                        </Link>
                    ))}
                </div>
                <p data-testid="hero-signature" className="mt-14 flex flex-wrap gap-x-5 gap-y-2 font-sans text-[10.5px] uppercase tracking-[0.36em] text-[#B0B6A6] animate-fade-up" style={{ animationDelay: "900ms" }}>
                    {HERO.signature.map((s, i) => (
                        <span key={s} className="inline-flex items-center gap-5">
                            {s}.{i < HERO.signature.length - 1 && <span aria-hidden="true" className="block w-4 h-px bg-[#C7A659]/60" />}
                        </span>
                    ))}
                </p>
            </div>
        </div>
    </section>
);

export default HeroRaquel;
